import React, {useEffect} from "react"
import {DiscountText} from "../../../util"
import {Space, Table, Tag, Typography} from "antd"
import {useClubMemberContext} from "../store/useClubMemberContext"

import ClubMemberBlack from "./ClubMemberBlack"
import ClubMemberEdit from "./ClubMemberEdit/ClubMemberEdit"
import ClubMemberFind from "./ClubMemberFind/ClubMemberFind"

const ClubMemberTable = () => {

    const {memberList, page, isLoading, onPageChange} = useClubMemberContext()
    const columns = [
        {
            title: '会员id',
            dataIndex: 'id',
            key: 'id',
            render: (text) => {
                return (<Typography.Text copyable>{text}</Typography.Text>)
            }
        },
        {
            title: '用户',
            dataIndex: 'memberName',
            key: 'memberName',
        },
        {
            title: '昵称',
            dataIndex: 'nickName',
            key: 'nickName',
        },
        {
            title: '电话',
            dataIndex: 'account',
            key: 'account',
            render: (text) => {
                return (<Typography.Text copyable>{text}</Typography.Text>)
            }

        },

        {
            title: '等级',
            dataIndex: 'discountName',
            key: 'discountName',
        },
        {
            title: '折扣',
            dataIndex: 'discount',
            key: 'discount',
            render: (text) => {
                return DiscountText(text)
            },
        },
        {
            title: '是否已绑定微信',
            dataIndex: 'isBound',
            key: 'isBound',
            render: (text) => {
                return <Tag color={text ? 'green' : 'red'}>{text ? '是' : '否'}</Tag>
            },
        },
        {
            title: '是否已拉黑',
            dataIndex: 'isInBlacklist',
            key: 'isInBlacklist',
            render: (_, record) => (
                <Tag color={record.isInBlacklist ? 'green' : 'red'}>{record.isInBlacklist ? '是' : '否'}</Tag>
            ),
        },
        {
            title: '操作',
            dataIndex: 'edit',
            key: 'edit',
            render: (text, record) => (
                <Space>
                    <ClubMemberEdit member={record}/>
                    <ClubMemberFind member={record}/>
                    <ClubMemberBlack member={record}/>
                </Space>
            ),
        },
    ]


    return (
        <div>
            <Table
                loading={isLoading}
                columns={columns}
                dataSource={memberList}
                rowKey='id'
                pagination={{
                    total: page.total,
                    onChange: (value,pageSize) => {
                        onPageChange(value,pageSize)
                    },
                }}
            />
        </div>
    )
}

export default ClubMemberTable


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberTable.js